import { Aeroespecialidad } from "./aeroespecialidad";
import { MedicionTanque } from "./MedicionTanque";

export class CargaDatos{
    aeroespecialidades: Aeroespecialidad[];
    medicionesTanques: MedicionTanque[];
}